// Splits an array into groups of at most `size`, for batching Firestore
// `where('__name__', 'in', ...)` queries against the 30-value cap.
const chunk = (array, size = 30) => {
  if (size <= 0) {
    throw new Error('chunk size must be greater than 0');
  }
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

module.exports = { chunk };
